import { CustomizedButton, CustomizedDialog } from '@components/Customized';
import React from 'react';
import { ConnectDrive } from './assets';
import { ConnectDriveDialogProps } from './types';
import useStyles from './useStyles';

const ConnectDriveDialogPresenter: React.FC<Pick<
  ConnectDriveDialogProps,
  'onClose' | 'files' | 'open' | 'onSubmit' | 'matches' | 'submitDisabled'
>> = ({
  children,
  matches,
  open,
  files,
  submitDisabled,
  onClose,
  onSubmit
}) => {
  const classes = useStyles();
  const isEmpty = files.length === 0;

  return (
    <CustomizedDialog
      open={open}
      onClose={onClose}
      color="primary"
      title="커넥트에서 파일 첨부"
      icon={
        <img
          width={matches ? 32 : 40}
          height={matches ? 32 : 40}
          src={ConnectDrive}
          alt=""
        />
      }
      maxWidth={720}
      borderRadius={matches ? 16 : 24}
      gutter={matches ? 16 : 24}
    >
      {children}
      <div className={classes['Connect-Drive-Bottom-CTA']}>
        <CustomizedButton
          variant="contained"
          color="default"
          className="cancel"
          size={matches ? 'medium' : 'large'}
          onClick={onClose}
        >
          취소
        </CustomizedButton>
        <CustomizedButton
          disabled={isEmpty || submitDisabled}
          variant="contained"
          color="primary"
          size={matches ? 'medium' : 'large'}
          onClick={onSubmit}
        >
          확인
        </CustomizedButton>
      </div>
    </CustomizedDialog>
  );
};

export default ConnectDriveDialogPresenter;
